module.exports = __webpack_public_path__ + "media/images/Rectangle_2-270a8ea645038424ef2c169c19bf14ee.png";